import social from "@/lib/prismicio/prismic-social.json";
import { useMemo } from "react";
export const useSocial = () => useMemo(() => social, []);
